import React from "react";

export default function AiraUserChat(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="#9747ff"
        fillRule="evenodd"
        d="M21.399 21.399c-1.168 1.227-2.729 1.974-4.683 2.24-1.371.282-2.943.398-4.716.351-1.772.047-3.344-.07-4.716-.35-1.954-.267-3.515-1.014-4.683-2.241C1.374 20.231.627 18.67.361 16.716.08 15.345-.037 13.773.01 12c-.048-1.772.069-3.344.35-4.716C.627 5.33 1.374 3.77 2.6 2.602 3.77 1.374 5.33.627 7.284.36 8.656.08 10.228-.037 12 .011c1.773-.048 3.345.069 4.716.35 1.954.266 3.515 1.013 4.683 2.24 1.227 1.168 1.974 2.73 2.24 4.683.281 1.372.398 2.944.35 4.716.048 1.773-.069 3.345-.35 4.716-.266 1.954-1.013 3.515-2.24 4.683z"
        clipRule="evenodd"
      >
      </path>
      <mask
        id="mask0_107_10405"
        width="24"
        height="24"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M21.399 21.399c-1.168 1.227-2.729 1.974-4.683 2.24-1.371.282-2.943.398-4.716.351-1.772.047-3.344-.07-4.716-.35-1.954-.267-3.515-1.014-4.683-2.241C1.374 20.231.627 18.67.361 16.716.08 15.345-.037 13.773.01 12c-.048-1.772.069-3.344.35-4.716C.627 5.33 1.374 3.77 2.6 2.602 3.77 1.374 5.33.627 7.284.36 8.656.08 10.228-.037 12 .011c1.773-.048 3.345.069 4.716.35 1.954.266 3.515 1.013 4.683 2.24 1.227 1.168 1.974 2.73 2.24 4.683.281 1.372.398 2.944.35 4.716.048 1.773-.069 3.345-.35 4.716-.266 1.954-1.013 3.515-2.24 4.683z"
          clipRule="evenodd"
        >
        </path>
      </mask>
      <g mask="url(#mask0_107_10405)">
        <path
          fill="#fff"
          d="M8.148 8.225L5.324 16H4.17l3.252-8.531h.744zM10.516 16l-2.83-7.775-.018-.756h.744l3.264 8.53zm-.147-3.158v.926H5.576v-.926zm2.45-5.373h2.824c.64 0 1.181.097 1.623.293.445.195.783.484 1.013.867.235.379.352.846.352 1.4 0 .391-.08.748-.24 1.073-.157.32-.383.593-.68.82a3 3 0 01-1.055.498l-.316.123h-2.655l-.011-.92h2.004c.406 0 .744-.07 1.013-.21.27-.145.473-.339.61-.58s.205-.51.205-.804c0-.328-.065-.615-.193-.861s-.332-.436-.61-.568c-.273-.137-.627-.205-1.06-.205h-1.694V16h-1.13zM17.804 16l-2.074-3.867 1.177-.006 2.104 3.803V16z"
        >
        </path>
      </g>
    </svg>
  );
}
